/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Actions_Admin_PanelInputs */

const es_settings_actions_admin_panel = /** @type {(inputs: Settings_Actions_Admin_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel Admin`)
};

const en_settings_actions_admin_panel = /** @type {(inputs: Settings_Actions_Admin_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin panel`)
};

/**
* | output |
* | --- |
* | "Admin panel" |
*
* @param {Settings_Actions_Admin_PanelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_actions_admin_panel = /** @type {((inputs?: Settings_Actions_Admin_PanelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Actions_Admin_PanelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_actions_admin_panel(inputs)
	return en_settings_actions_admin_panel(inputs)
});
export { settings_actions_admin_panel as "settings.actions.admin_panel" }